// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconSafetyScreening = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M8 15v2h2v-2h2v-2h-2v-2H8v2H6v2zm6 0h4v-2h-4z" />,
    <path fillRule="evenodd" d="M2 3h20v18H2zm2 2v2h16V5zm16 4H4v10h16z" />
  );
export default SvgIconSafetyScreening;
